export default __webpack_public_path__ + "facebook-hrz-v1.svg";